import api from '../api';
import { tokenService } from '../auth/tokenService';

export const role = {
  getRole: async (roleId) => {
    try {
      const response = await api.get(`roles/cms/${roleId}`, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateRole: async (roleId, roleData) => {
    try {
      const response = await api.put(`roles/cms/${roleId}`, roleData, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getDataRole: async (params) => {
    try {
      const response = await api.get('/rolescms/filtered/paginated', {
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createRole: async (roleData) => {
    try {
      const response = await api.post('roles/cms/create', roleData, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getAllRoles: async () => {
    try {
      const response = await api.get('roles/cms/all', {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  
  rolesWithPermissions: async () => {
    try {
      const response = await api.get('roles/cms/modules-with-permissions', {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getRolePermissions: async (roleId) => {
    try {
      const response = await api.get(`roles/cms/${roleId}`, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  downloadRoles: async (params) => {
    try {
      const response = await api.get('roles/cms/export/excel', {
        responseType: 'blob',
        params,
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`,
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      });

      // Crear el blob y el enlace de descarga
      const blob = new Blob([response.data], { 
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'users.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteRole: async (roleId) => {
    try {
      const response = await api.delete(`roles/cms/${roleId}`, {
        headers: {
          'Authorization': `Bearer ${tokenService.getAccessToken()}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

};
  